<app-topbar></app-topbar>
<app-sidebar></app-sidebar>

<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header">
      <div class="page-head">
        <div>
          <h3 class="page-head__title">IMTO - {{ data?.name }}</h3>
          <p class="page-head__sub">Profile Details</p>
        </div>
        <div class="page-head__tools">
          <span class="page-pill page-pill--balance">
            <i class="fa fa-money"></i> Current Balance
            <strong>NGN {{ $safeNavigationMigration(data?.balance) | number }}</strong>
          </span>
        </div>
      </div>
    </div>


    <div class="content-body">
      <!-- Revenue, Hit Rate & Deals -->
      <div class="row">
        <div class="col-12">
          <div class="row  all-details" >
            <div class="col-md-6">

              <div class="card-header border-right row" style="height: 100%">

                <div class="col-md-5 heading">IMTO Name</div>
                <div class="col-md-7 detail">{{data?.name  || 'Not Specified'}}</div>

                <div class="col-md-5 heading">Telephone</div>
                <div class="col-md-7 details">{{data?.phone_number  || 'Not Specified'}}</div>

                <div class="col-md-5 heading">Email</div>
                <div class="col-md-7 details">{{data?.email  || 'Not Specified'}}</div>

                <div class="col-md-5 heading">Address</div>
                <div class="col-md-7 detail">{{data?.address  || 'Not Specified'}}</div>

                <div class="col-md-5 heading">State/Province</div>
                <div class="col-md-7 details">{{data?.state?.name  || 'Not Specified'}}</div>

                <div class="col-md-5 heading">Country</div>
                <div class="col-md-7 details">{{data?.country?.name || 'Not Specified'}}</div>

              </div>

            </div>
            <div class="col-md-6">
              <div class="card-header border-right no-border row" style="height: 100%">
                <div class="col-md-5 heading">Admins</div>
                <div class="col-md-7 details">
                  @for (admin of data?.admins; track admin) {
                    <div><a [routerLink]="['/admin',$safeNavigationMigration(admin?.slug)]">{{admin?.name}}</a></div>
                  }
                  @if (data?.admins?.length === 0) {
                    <div class="alert alert-light" style="color: white; margin: 0 15px 15px 15px;">
                      No Admin Registered for this IMTO
                    </div>
                  }
                </div>

                <div class="col-md-5 heading">Activation Mode</div>
                <div class="col-md-7 details" style="text-transform: capitalize">
                  <span class="btn btn-success">{{data?.active_env || 'Not Specified'}}</span>
                </div>
              </div>

            </div>


          </div>
        </div>
      </div>


    </div>
    <div class="content-header row">
      <div class="content-header-left col-md-6 col-12 mb-2">
        <!--<h3 class="content-header-title mb-0">IMTO - Name</h3>-->
        <div class="row breadcrumbs-top">
          <div class="breadcrumb-wrapper col-12">
            <ol class="breadcrumb mt-30" style="margin-top: 30px">
              Transaction History
            </ol>
          </div>
        </div>
      </div>

    </div>
    <div class="content-body">
      <!-- Revenue, Hit Rate & Deals -->
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">



            </div>
            <div class="card-content">
              <div class="table-responsive hover">
                @if (transactions?.length > 0) {
                  <table class="table table-de mb-0">
                    <thead>
                      <tr>
                        <th>Reference ID</th>
                        <th>Amount</th>
                        <th>Date</th>
                        <th>Status</th>
                        <th>Info</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (transaction of transactions | paginate: config; track transaction) {
                        <tr class="pull-up">
                          <td> #{{transaction.transaction_ref}}</td>
                          <td> NGN {{transaction.payout_amount | number}}</td>
                          <td>{{transaction.created_at | date }}</td>
                          <td><span class="status-badge status-{{transaction.status}}" >{{transaction.status | uppercase}}</span></td>
                          <td>{{transaction.message  | slice:0:30  || 'Not Specified'}}...</td>
                          <td class="details">
                            <a [routerLink]="['/transaction',transaction.transaction_ref]" class="details">Details </a><i class="icons icon-leftt"></i>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                }
                @if (transactions?.length > 0) {
                  <div style="text-align: center; width: 100%;"><pagination-controls (pageChange)="pageChanged($event)"></pagination-controls></div>
                }
                @if (transactions?.length === 0) {
                  <div class="alert alert-light" style="color: white; margin: 0 15px 15px 15px;">
                    No Transactions yet
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>


  </div>
</div>
<app-bottombar></app-bottombar>
